<template>
	<div class="new-insert">
		<div class="">
			<el-steps :active="tab" class="steps-wrap">
			  <el-step title="个人信息">
				  <div class="icon-box" slot="icon" @click="checkTab('Personal', true)">
					   <el-image class="insert-icon" v-if="step == 'Personal' || type == 'update'" :src="require('@/assets/images/personal-icon.png')"></el-image>
					   <el-image class="insert-icon" v-if="step != 'Personal' && type == 'insert'" :src="require('@/assets/images/pay-success.png')"></el-image>
				  </div>
			  </el-step>
			  <el-step title="问卷信息" v-if="!hasFb">
				  <div class="icon-box" slot="icon" @click="checkTab('Questions', true)">
					 <el-image v-if="step == 'Questions' || type == 'update'" class="insert-icon" :src="require('@/assets/images/quest-int.png')"></el-image>
					 <el-image v-if="step == 'Personal' && type == 'insert'" class="insert-icon" :src="require('@/assets/images/quest.png')"></el-image>
					 <el-image class="insert-icon" v-if="step == 'Bodily' && type == 'insert'" :src="require('@/assets/images/pay-success.png')"></el-image>
				  </div>
			  </el-step>
			  <el-step title="问卷信息" v-if="hasFb">
					<div class="icon-box" slot="icon" @click="checkTab('InsertFb', true)">
						<el-image v-if="step == 'InsertFb' || type == 'update'" class="insert-icon" :src="require('@/assets/images/quest-int.png')"></el-image>
						<el-image v-if="step == 'Personal' && type == 'insert'" class="insert-icon" :src="require('@/assets/images/quest.png')"></el-image>
						<el-image class="insert-icon" v-if="step == 'Bodily' && type == 'insert'" :src="require('@/assets/images/pay-success.png')"></el-image>
					</div>
			  </el-step>
			  <el-step title="体型信息">
				  <div class="icon-box" slot="icon" @click="checkTab('Bodily', true)">
					  <el-image v-if="step == 'Bodily' || type == 'update'" class="insert-icon" :src="require('@/assets/images/shape-int.png')"></el-image>
					  <el-image v-if="(step == 'Personal' || step == 'Questions' || step == 'InsertFb') && type == 'insert'" class="insert-icon" :src="require('@/assets/images/shape.png')"></el-image>
					  <!-- <el-image class="insert-icon" v-if="type == 'insert'" :src="require('@/assets/images/pay-success.png')"></el-image> -->
				  </div>
			  </el-step>
			</el-steps>
		</div>
		<router-view :type="type" :is="step" @handleHasFb="handleHasFb" :clearData="clearData" :formData="formData" @stopQuery="$emit('stopQuery')" @checkTab="checkTab"></router-view>
	</div>
</template>

<script>
	
	import { packageOpen } from '@/utils/axios'
	// const Tabs = () => import('./Tabs');
	const Personal = () => import('./Personal');
	const Questions = () => import('./Questions');
	const InsertFb = () => import('./InsertFb');
	const Bodily = () => import('./Bodily');
	
	export default{
		name: 'newInsert',
		data() {
			return {
				tab: 1 ,//默认从个人信息开始填写
				step: 'Personal',
				hasFb: false,
				isMuying: false,
				formData: {},
				defFormData: {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					package: '',
					
					corp: '',
					
					height: '',
					weight: '',
					// bust: '',
					waist: '',
					hip: '',
					fat: '',
					chest: '',
					
					area: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"kdis": "K01", "level": "0"},
						{"kdis": "K02", "level": "0"},
						{"kdis": "K03", "level": "0"},
						{"kdis": "K04", "level": "0"},
						{"kdis": "K05", "level": "0"},
						{"kdis": "K06", "level": "0"},
						{"kdis": "K07", "level": "0"},
						{"kdis": "K08", "level": "0"},
						{"kdis": "K09", "level": "0"},
						{"kdis": "K10", "level": "0"},
						{"kdis": "K11", "level": "0"},
						{"kdis": "K12", "level": "0"},
						{"kdis": "K13", "level": "0"},
						{"kdis": "K14", "level": "0"},
						{"kdis": "K15", "level": "0"},
						{"kdis": "K16", "level": "0"},
						{"kdis": "K17", "level": "0"},
						{"kdis": "K18", "level": "0"},
						{"kdis": "K19", "level": "0"}
					],
					oper:[],
					famdis:[],
					operator: '',// 当前后台操作人手机号
					
					//骨折信息
					qnmh: '',
					qntimes: '',
					qnpbf: '',
					selfcare: '',
					tscore: '',
					fbdisease: [
						{"fdis": "F00", "level": "1"},
						{"fdis": "F01", "level": "0"},
						{"fdis": "F02", "level": "0"},
						{"fdis": "F03", "level": "0"},
						{"fdis": "F04", "level": "0"},
						{"fdis": "F05", "level": "0"},
						{"fdis": "F06", "level": "0"},
						{"fdis": "F07", "level": "0"},
						{"fdis": "F08", "level": "0"},
						{"fdis": "F09", "level": "0"},
						{"fdis": "F10", "level": "0"},
						{"fdis": "F11", "level": "0"},
						{"fdis": "F12", "level": "0"},
						{"fdis": "F13", "level": "0"},
						{"fdis": "F14", "level": "0"},
						{"fdis": "F15", "level": "0"},
						{"fdis": "F16", "level": "0"},
						{"fdis": "F17", "level": "0"},
						{"fdis": "F18", "level": "0"},
						{"fdis": "F19", "level": "0"},
						{"fdis": "F20", "level": "0"},
						{"fdis": "F21", "level": "0"},
						{"fdis": "F22", "level": "0"},
						{"fdis": "F23", "level": "0"},
						{"fdis": "F24", "level": "0"},
						{"fdis": "F25", "level": "0"},
						{"fdis": "F26", "level": "0"},
						{"fdis": "F27", "level": "0"},
						{"fdis": "F28", "level": "0"},
						{"fdis": "F29", "level": "0"},
						{"fdis": "F30", "level": "0"},
						{"fdis": "F31", "level": "0"},
						{"fdis": "F32", "level": "0"},
						{"fdis": "F33", "level": "0"},
						{"fdis": "F34", "level": "0"}
					],
					service: [
						{"svc": "V01", "need": "1"},
						{"svc": "V02", "need": "1"},
						{"svc": "V03", "need": "1"},
						{"svc": "V04", "need": "1"},
						{"svc": "V05", "need": "1"},
						{"svc": "V06", "need": "1"},
						{"svc": "V07", "need": "1"},
						{"svc": "V08", "need": "1"},
						{"svc": "V09", "need": "1"},
						{"svc": "V10", "need": "1"},
						{"svc": "V11", "need": "1"},
						{"svc": "V12", "need": "1"},
						{"svc": "V13", "need": "1"},
						{"svc": "V14", "need": "1"},
						{"svc": "V15", "need": "1"},
						{"svc": "V16", "need": "1"},
						{"svc": "V17", "need": "1"},
					],
				}
			}
		},
		components: {
			// Tabs,
			Personal,
			Questions,
			Bodily,
			InsertFb,
		},
		props: [ 'type', 'dataId', 'isBo', 'reportCode', 'clearData' ],
		mounted() {
			this.formData = this.defFormData
			if(this.dataId) {
				packageOpen({act: 'query', id: this.dataId}).then((res) => {
					if(res.code == 200) {
						let dataBase = JSON.parse(window.atob(res.data))
						let input_data = dataBase.input_data
						let data = {...dataBase, ...input_data}
						delete data.input_data
						if(data.fbdisease  && data.qnmh) {
							this.handleHasFb(true)
						}
						if(this.isBo) {
							data.examine = [
								{"ne": "WBC", "ve": "", "ut": "A"},
								{"ne": "HGB", "ve": "", "ut": "A"},
								{"ne": "PLT", "ve": "", "ut": "A"},
								{"ne": "FG", "ve": "", "ut": "B"},
								{"ne": "HBA1C", "ve": "", "ut": "A"},
								{"ne": "CHOL", "ve": "", "ut": "B"},
								{"ne": "LDLC", "ve": "", "ut": "B"},
								{"ne": "HDLC", "ve": "", "ut": "B"},
								{"ne": "TG", "ve": "", "ut": "B"},
								{"ne": "GOT", "ve": "", "ut": "A"},
								{"ne": "GPT", "ve": "", "ut": "A"},
								{"ne": "ALP", "ve": "", "ut": "A"},
								{"ne": "ALB", "ve": "", "ut": "B"},
								{"ne": "CRE", "ve": "", "ut": "B"},
								{"ne": "UA", "ve": "", "ut": "B"},
								{"ne": "EGFR", "ve": "", "ut": "A"}
							]
							this.formData = data
							if(this.formData.yy_user_id) {
								this.formData.yyuserid = this.formData.yy_user_id
							}
							this.checkTab('Biochemical')
						} else {
							this.formData = data
							if(this.formData.yy_user_id) {
								this.formData.yyuserid = this.formData.yy_user_id
							}
						}
					}
				}) 
				if(this.type == 'update') {
					this.tab = 6
					return
				}	
			}
		},
		watch: {
				
		},
		methods: {
			handleMuying(isMuying) {
				this.isMuying = isMuying
			},
			handleHasFb(hasFb) {
				this.hasFb = hasFb
			},
			//切换tab 参数 tab组件名
			checkTab(tab, isTab) {
				if(this.type == 'insert' && isTab) {
					return;
				}
				if(this.type == 'update') {
					this.tab = 6
					this.step = tab
					return
				}	
				switch (tab) {
					case 'Personal' :
					this.tab = 1
					break
					case 'Questions' :
					this.tab = 2
					break
					case 'Bodily' :
					this.tab = 3
					break
					case 'InsertFb' :
					this.tab = 2
					break
				}
				this.step = tab
			}
		}
	}
</script>

<style scoped>
	.new-insert >>> .el-step__icon {
		width: 36px;
		height: 36px;
		background-color: #F2F4FA;
		border-radius: 50%;
		cursor: pointer;
	}
	.new-insert >>> .el-step__icon.is-text {
		border: none;
	}
	.new-insert >>> .el-step.is-horizontal .el-step__line {
		height: 6px;
		top: 16px;
		background-color: #F2F4FA;
	}
	.new-insert >>> .el-step__line-inner {
		height: 6px;
		top: 16px;
		background: #6883FB;
	}
	.new-insert >>> .el-step__title {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		line-height: 16px;
	}
	.new-insert >>> .el-step__main {
		position: relative;
		left: -6px;
		margin-top: 8px;
	}
</style>

<style lang="scss" scoped>
	.steps-wrap {
		width: 752px;
		margin: 16px auto 0;
	}
	.icon-box {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		// background-color: #6883FB;
		border-radius: 50%;
	}
	
	.el-icon-user-solid {
		font-size: 20px;
		color: #fff;
	}
	
	.insert-icon {
		width: 36px;
		height: 36px;
	}
</style>
